// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Custom imports
import findIndex from "lodash/findIndex";

// Initial State
const initialState = {
  selectedAssets: [],
  taskName: "",
  description: "",
  tags: "",
  mode: "create",
  taskId: null,
  duration: 0,
  durationStartTimeStamp: 0,
  durationFlag: false,
};

// Redux Slice for Task
const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    addAsset(state, { payload }) {
      return {
        ...state,
        selectedAssets: [...state.selectedAssets, payload],
      };
    },
    removeAsset(state, { payload }) {
      let assetsArray = [...state.selectedAssets];
      let pos = findIndex(assetsArray, { id: payload });
      assetsArray.splice(pos, 1);
      return {
        ...state,
        selectedAssets: assetsArray,
      };
    },
    setAllSelectedAssets(state, { payload }) {
      return {
        ...state,
        selectedAssets: payload,
      };
    },
    setTaskName(state, { payload }) {
      return {
        ...state,
        taskName: payload,
      };
    },
    setDescription(state, { payload }) {
      return {
        ...state,
        description: payload,
      };
    },
    setTags(state, { payload }) {
      return {
        ...state,
        tags: payload,
      };
    },
    setMode(state, { payload }) {
      return {
        ...state,
        mode: payload,
      };
    },
    setTaskId(state, { payload }) {
      return {
        ...state,
        taskId: payload,
      };
    },
    startDuration(state, { payload }) {
      if (state.durationFlag) {
        let startdateObj = new Date();
        return {
          ...state,
          durationStartTimeStamp: startdateObj.getTime(),
        };
      }
    },
    stopDuration(state, { payload }) {
      if (state.durationFlag) {
        let enddateObj = new Date();
        let endtimestamp = enddateObj.getTime();
        let duration = 0;
        if (state.durationStartTimeStamp != 0) {
          duration =
            +endtimestamp -
            +state.durationStartTimeStamp +
            Number(state.duration);
        }

        return {
          ...state,
          durationStartTimeStamp: 0,
          duration: duration,
        };
      }
    },
    setDurationFlag(state, { payload }) {
      return {
        ...state,
        durationFlag: payload,
      };
    },
  },
});

export const taskSliceActions = taskSlice.actions;

export default taskSlice;
